export default __webpack_public_path__ + "i18n/ru.3aec76ea41f10a3239e7198726689de6.json";